module.exports = require("@material-ui/icons/ExpandMore");